import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Session lives in an httpOnly cookie set by the backend.
const api = axios.create({ baseURL: API, withCredentials: true });

// Resolve stored relative image paths (/api/files/...) to absolute
export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};

export default api;
